import { withInstall } from '@element-plus/utils/with-install'
import TreeV2 from './src/tree.vue'

export const ElTreeV2 = withInstall(TreeV2)
export default ElTreeV2
